import { render, staticRenderFns } from "./register.vue?vue&type=template&id=30950acf&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=30950acf&prod&scoped=true&lang=scss"
import style1 from "./register.vue?vue&type=style&index=1&id=30950acf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30950acf",
  null
  
)

export default component.exports